function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 15V16H25V15H24ZM24 1H25V0H24V1ZM7 12H2V14H7V12ZM7 8H2.75V10H7V8ZM7 4H3.75V6H7V4ZM20.25 16H24V14H20.25V16ZM25 15V1H23V15H25ZM24 0H20.25V2H24V0ZM6.956 8H2.706V10H6.956V8ZM6.956 4H3.706V6H6.956V4Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.95605 12H3.95605V14H6.95605V12ZM3.95605 12C3.40434 12 2.95605 11.5517 2.95605 11H0.956055C0.956055 12.6563 2.29977 14 3.95605 14V12ZM2.95605 11C2.95605 10.4483 3.40434 10 3.95605 10V8C2.29977 8 0.956055 9.34372 0.956055 11H2.95605ZM3.95605 10H6.95605V8H3.95605V10ZM4.45605 8C3.90434 8 3.45605 7.55172 3.45605 7H1.45605C1.45605 8.65628 2.79977 10 4.45605 10V8ZM3.45605 7C3.45605 6.44828 3.90434 6 4.45605 6V4C2.79977 4 1.45605 5.34372 1.45605 7H3.45605ZM4.45605 6H6.95605V4H4.45605V6Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.95605 5C4.85205 5 3.95605 4.104 3.95605 3V3C3.95605 1.896 4.85205 1 5.95605 1H20.0001V15.25L16.1701 21.56C15.5641 22.494 14.8681 23 14.0001 23C13.8161 23 13.6261 22.974 13.4401 22.92C12.3801 22.612 11.7721 21.5 12.0801 20.44L13.2501 17H3.95605C2.85205 17 1.95605 16.104 1.95605 15V15C1.95605 13.896 2.85205 13 3.95605 13H6.95605",
  stroke: "white",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgThumbsdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdown);
export default __webpack_public_path__ + "static/media/thumbsdown.d6f698ba.svg";
export { ForwardRef as ReactComponent };